import { CSSProperties, useEffect, useRef, useState } from "react";
import { clsx } from "clsx";
import { devPrint } from "@/utils/devUtils";
import { log } from "console";

interface IDropdownButton<T> {
  onChange: (value: T) => void;
  items: { title: string | JSX.Element; value: T }[];
  title?: string;
  selected: T | undefined;
  color?: string;
  className?: string;
  child?: JSX.Element;
  style?: CSSProperties;
  key?: String;
  onToggle?: (open: boolean) => void;
}

const DropdownButton = <T,>(props: IDropdownButton<T>) => {
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.onToggle) {
      props.onToggle(open);
    }
  }, [open]);

  useEffect(() => {
    const toggleDropdown = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current!.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("click", toggleDropdown);
    return () => document.removeEventListener("click", toggleDropdown);
  }, []);
  let selectedTitle = "" as string | JSX.Element;
  for (var item of props.items) {
    if (item.value === props.selected) {
      selectedTitle = item.title;
    }
  }
  return (
    <div className="flex justify-center relative" ref={dropdownRef}>
      {props.child ? (
        <div
          onClick={() => {
            setOpen(!open);
          }}
        >
          {props.child}
        </div>
      ) : (
        <button
          style={
            props.style ?? {
              // minWidth: 200,
              backgroundColor: props.color,
              color: props.color === "white" ? "black" : undefined,
              borderBottom:
                props.color === "white" ? "1px black solid" : undefined,
            }
          }
          id="dropdownDefaultButton"
          data-dropdown-toggle="dropdown-btn"
          onClick={() => {
            setOpen(!open);
          }}
          className={clsx(
            props.className ??
            "text-white bg-light-brown focus:outline-none focus:ring-dark-brown font-medium  text-sm px-5 py-2.5 text-center inline-flex items-center"
          )}
          type="button"
        >
          <div className="flex flex-row items-center justify-between w-full">
            <div className="text-sm flex flex-col text-left">
              <span>{props.title}</span>
              <span className="font-light text-xs">{selectedTitle}</span>
            </div>
            <svg
              className="w-2.5 h-2.5 ml-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </div>
        </button>
      )}
      <div
        id="dropdown-btn"
        style={{
          display: open ? "block" : "none",
          maxHeight: 200,
          position: "absolute",
          width: "100%",
        }}
        className="top-8 md:top-12 z-10 bg-white divide-y rounded-[1rem] shadow-[0_0_20px_0_#00000026]"
      >
        <ul
          className="py-2 text-sm text-gray-800"
          aria-labelledby="dropdownDefaultButton"
        >
          {props.items.map((e, i) => {
            return (
              <li
                key={
                  (props.key ?? "") +
                  (props.title ?? "title") +
                  "dropdown" +
                  e.title +
                  i
                }
              >
                <a
                  href="#"
                  className={
                    "block text-[1rem] leading-[1.8rem] px-4 py-2 hover:text-black hover:bg-[#F1DECC] transition duration-300"
                  }
                  onClick={(event) => {
                    event.preventDefault();
                    props.onChange(e.value);
                    setOpen(false);
                  }}
                >
                  {e.title}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default DropdownButton;
